import { tags } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function TagsSection() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-start lg:gap-14">
          <SectionHeading
            index="06"
            title="热门标签"
            desc="平台常用的分类标签都在这里。按标签找更快——想要更新快的就看「小时级更新」，想要轻松的看「轻量阅读」。"
          />
          <div className="flex flex-wrap gap-2.5">
            {tags.map((tag, index) => (
              <a
                key={tag}
                href="#collections"
                className={`cursor-pointer whitespace-nowrap rounded-full border px-3.5 py-2 text-sm transition-colors ${
                  index % 5 === 0
                    ? "border-primary-200 bg-primary-100 text-primary-800 hover:bg-primary-200"
                    : index % 5 === 1
                      ? "border-accent-200 bg-accent-100 text-accent-800 hover:bg-accent-200"
                      : "border-background-200 bg-background-50 text-foreground-700 hover:border-secondary-300 hover:bg-secondary-100 hover:text-secondary-900"
                }`}
              >
                {tag}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}